module.exports = __webpack_public_path__ + "img/rs_multigreenL.4a36a9a.png";